import {Component, Input, ViewChild} from '@angular/core';
import {UserProfile} from '../../user-profile';
import {HorseResponse, UserResponse} from '../../../../@shared/models/response.module';
import {Horses} from '../../../../@shared/services/horses';
import {AQH_HOR_0, AQH_HOR_3, AQH_HOR_4} from '../../../../@shared/models/input.module';
import {ModalComponent} from '../../../../@shared/components/modal-component/modal-component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddHorse} from './components/add-horse/add-horse';
import {EditHorse} from './components/edit-horse/edit-horse';
import {DeleteModal} from '../../../../@shared/components/delete-modal/delete-modal';

@Component({
  selector: 'app-user-profile-horses',
  standalone: false,
  templateUrl: './user-profile-horses.html',
  styleUrl: './user-profile-horses.css'
})
export class UserProfileHorses {
  @Input() user: UserResponse
  horses: HorseResponse[]
  loading: boolean = false;
  horseToEdit: HorseResponse | null = null;
  deleteHorseId: number | null = null;

  constructor(private horseService: Horses,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getHorses()
  }


  getHorses() {
    this.loading = true;
    let payload: AQH_HOR_0 = {
      user_id: this.user.user_id
    }
    this.horseService.getHorses(payload).subscribe((res) => {
      this.horses = res
      this.loading = false;
      console.log(this.horses)
    })
  }

  openModal() {
    let modalRef = this.modalService.open(AddHorse, { size: 'lg', centered: true });
    modalRef.componentInstance.user = this.user;
  }

  openEditModal(horse: HorseResponse) {
    let modalRef = this.modalService.open(EditHorse, { size: 'lg', centered: true });
    modalRef.componentInstance.horse = horse;
  }
  //
  // openDeleteModal(horse: HorseResponse) {
  //   this.deleteHorseId = horse.horse_id;
  //
  // }

  deleteHorse(event: any) {
    let modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = 'Are you sure you want to delete this horse? This action cannot be undone.';
    modalRef.result.then((result) => {
      if (result) {
        let params: AQH_HOR_3 = {
          horse_id: event.horse_id
        }
        this.horseService.deleteHorse(params).subscribe((res) => {
          this.deleteHorseId = null;

          this.getHorses();
        });
      }
    })
  }

  protected readonly event = event;
}
